import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-until",
  "use": "icon-until-usage",
  "viewBox": "0 0 9 2",
  "content": "<symbol viewBox=\"0 0 9 2\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-until\">\n<rect width=\"9\" height=\"2\" fill=\"#999999\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol